import React, { useEffect, useMemo, useState } from "react";
import {
  Form,
  Row,
  Col,
  Card,
  CardBody,
  Table,
  CardTitle,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Button,
  ModalBody,
  ModalHeader,
  Modal,
} from "reactstrap";
import { useTable, usePagination, useGlobalFilter } from "react-table";
import Pagi2 from "common/utils/Pagi2";
import { CommonTableContainer } from "common/utils/ComonTableContainer";
import moment from "moment";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import configure from "configure";
import Swal from "sweetalert2";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import userImg from "../../assets/images/users/AdminImg.png";

const AddNotes = ({ id }) => {
  const [Data, setData] = useState([]);
  const [Loading, setloading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editNoteId, setEditNoteId] = useState(null);
  const [form, setForm] = useState({
    description: "",
    callTime: "",
    attachment: null,
  });

  useEffect(() => {
    fetchNotes();
  }, []);

  const fetchNotes = async () => {
    const token = secureLocalStorage.getItem("Token");
    try {
      const res = await axios.post(
        `${configure.apiUrl}/leads/notes`,
        {
          lead_id: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.data?.success) {
        setloading(false);
        setData(res?.data?.notes?.reverse());
      }
    } catch (e) {
      setloading(false);
      console.log(e);
    } finally {
      setloading(false);
    }
  };

  const openAddModal = () => {
    setEditNoteId(null);
    setForm({ description: "", callTime: "", attachment: null });
    setIsModalOpen(true);
  };

  const openEditModal = (note) => {
    setEditNoteId(note.id);
    setForm({
      description: note.description || "",
      callTime: note.date ? moment(note.date).format("YYYY-MM-DDTHH:mm") : "",
      attachment: null,
    });
    setIsModalOpen(true);
  };

  const handleFormSubmit = async () => {
    const token = secureLocalStorage.getItem("Token");
    const payload = new FormData();
    console.log(form)
    payload.append("lead_id", id);
    payload.append("description", form.description);
    payload.append("date", form.callTime);
    if (form.attachment) payload.append("lead_note_file", form.attachment);

    try {
      const url = editNoteId
        ? `${configure.apiUrl}/leads/notes/${editNoteId}`
        : `${configure.apiUrl}/leads/notes/add`;

      const method = editNoteId ? 'put' : 'post';

      await axios[method](url, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      Swal.fire(
        "Success",
        editNoteId ? "Note updated!" : "Note added!",
        "success"
      );
      setIsModalOpen(false);
      fetchNotes();
    } catch (err) {
      console.log(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  const ondelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this Note!",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "No, cancel",
      confirmButtonText: "Yes, delete it!",
      dangerMode: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setloading(true);
        const Token = secureLocalStorage.getItem("Token");
        try {
          const response = await axios({
            method: "delete",
            url: `${configure.apiUrl}/leads/notes/${id}`,
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${Token}`
            },
          });

          // Show success alert
          await Swal.fire({
            icon: "success",
            text: "Note Deleted Successfully",
          });

          // Update state with new data
          fetchNotes()
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Lead Delete Cancelled",
          });
        } finally {
          setloading(false);
        }
      }
    });
  };
  console.log(form?.description, Data)
  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h4 className=" text-dark">Notes</h4>
                      <button
                        //  to={`${configure.appUrl}/add-lead`}
                        onClick={() => openAddModal()}
                        className=" btn ms-md-2 btn-save  btn-label me-2"
                      >
                        <i className="fas fa-plus me-1 label-icon"></i> Notes
                      </button>
                    </div>
                  </CardTitle>

                  <div>
                    {Data?.length != 0 ? (
                      <ul className="verti-timeline list-unstyled notes-box">
                        {Data.map((item, index) => {
                          console.log(item?.description)
                          return (
                            <li
                              key={index}
                              className="event-list position-relative"
                            >
                              <div className="event-timeline-dot">
                                <img
                                  src={
                                    item?.userDetails?.name
                                      ? `${configure.marsimg}/${item?.userDetails?.avatar}`
                                      : userImg
                                  }
                                  className="userImg me-3"
                                  alt="User"
                                />
                              </div>
                              <div className="d-flex">
                                <div className="note flex-grow-1 ms-4 py-2 rounded ps-4">
                                  <div className="d-flex justify-content-between">
                                    <div>
                                      <p className="text-muted mb-4">
                                        <h6 className="d-inline me-2">
                                          By {item?.userDetails?.name}
                                        </h6>
                                        {moment(item?.created_at).format(
                                          "YYYY-MM-DD HH:MM:SS"
                                        )}{" "}
                                        <span className="pl-15">
                                          Got in touch with this Customer at{" "}
                                          {moment(item?.date).format("YYYY-MM-DD HH:MM:SS")}
                                        </span>
                                      </p>
                                      <i className="bi bi-triangle-fill note-icon"></i>
                                    </div>
                                    <div>
                                      <button
                                        onClick={() =>
                                          openEditModal(item)
                                        }
                                        className="btn btn-sm btn-outline-secondary me-1"
                                        title="View"
                                      >
                                        <i className="fas fa-pen"></i>
                                      </button>
                                      <button
                                        onClick={() => {
                                          ondelete(item.id);
                                        }}
                                        className="btn btn-sm btn-outline-danger me-1"
                                        title="View"
                                      >
                                        <i className="fas fa-trash-alt"></i>
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    dangerouslySetInnerHTML={{__html:item?.description}}
                                  />
                                </div>
                              </div>
                              <div className="note ms-4 ps-4">
                                {item?.link && (
                                  <div>
                                    Attachment:{" "}
                                    <a
                                      target="_blank"
                                      rel="noreferrer"
                                      className="activity-log-btn text-info"
                                      href={item?.link} // Replace with your static link
                                    >
                                      <i className="fas fa-eye pe-1"></i>View
                                    </a>
                                  </div>
                                )}
                              </div>
                            </li>
                          )
                        }
                        )}
                      </ul>
                    ) : null}
                    {Data?.length == 0 ? (
                      <p>No Notes has been Added Yet</p>
                    ) : null}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <Modal
        size="xl"
        isOpen={isModalOpen}
        toggle={() => setIsModalOpen(!isModalOpen)}
      >
        <ModalHeader toggle={() => setIsModalOpen(!isModalOpen)}>
          {editNoteId ? "Edit Note" : "Add Note"}
        </ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label>Description</Label>
              <CKEditor
                editor={ClassicEditor}
                data={form.description || ''}
                onReady={(editor) => {
                  // You can store the "editor" and use when it is needed.
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  setForm({ ...form, description: data });
                }}
              />
            </FormGroup>
            <FormGroup>
              <Label>Call Time</Label>
              <Input
                type="datetime-local"
                value={form.callTime}
                onChange={(e) => setForm({ ...form, callTime: e.target.value })}
              />
            </FormGroup>
            <FormGroup>
              <Label>Attachment</Label>
              <Input
                type="file"
                onChange={(e) =>
                  setForm({ ...form, attachment: e.target.files[0] })
                }
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            className="btn btn-save"
            color="primary"
            onClick={handleFormSubmit}
          >
            {editNoteId ? "Update" : "Add"}
          </Button>
          <Button color="secondary" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

export default AddNotes;
